import React, { Component } from 'react';
import PropTypes from 'prop-types';
// classnames
import classNames from 'classnames';
// jl-design-system
import { SecondaryButton } from 'jl-design-system/elements/button/Button';
import Checkbox from 'jl-design-system/components/checkbox/Checkbox';
import Select from 'jl-design-system/elements/select/Select';
import Input from 'jl-design-system/elements/input/Input';
import env from 'jl-design-system/utils/env/env';
// lodash
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
// redux
import { connect } from 'react-redux';
import { setFeatureOverrideCookie } from '../../../redux/reducers/config/configReducer';
//
import featureConstants from '../../../constants/featureConstants';
import { loadScript } from '../../../utils';
import { SET_LOG_ANALYTICS, UPDATE_FEATURE } from '../../../constants/actionConstants';
import PaymentWalletStubs from '../payment-wallet-stubs/PaymentWalletStubs';
import { setCanMakeGooglePayPayments } from '../../../redux/actions/payment/googlePayActions';
import loadPaymentWalletStubs from '../../utils/paymentWallet/loadPaymentWalletStubs';
import {
  allowCookieGroup,
  refuseCookieGroup,
  removeCookieGroupPreference,
  getCookieGroupPermission,
} from '../../../utils/pecr/pecr';
import {
  setStorageItem,
  getStorageItem,
} from '../../../utils/storage/storage';
// styles
import styles from './dev-console.scss';

// See README for guidance on using DevConsole options in dev environment

const updateFeature = (id, enabled) => ({
  type: UPDATE_FEATURE,
  id,
  enabled,
});

export class DevConsole extends Component {
  static propTypes = {
    applicationType: PropTypes.string,
    dispatch: PropTypes.func,
    features: PropTypes.arrayOf(PropTypes.shape({})),
    googlePayPaymentsClientHasBeenCreated: PropTypes.bool,
    googlePayStubsEnabled: PropTypes.bool,
    // eslint-disable-next-line
    pathname: PropTypes.string,
    setCanMakeGooglePayPayments: PropTypes.func,
    showHeader: PropTypes.bool,
  };

  static defaultProps = {
    applicationType: '',
    dispatch: window.defaultFunc,
    features: [],
    googlePayPaymentsClientHasBeenCreated: false,
    googlePayStubsEnabled: false,
    logAnalytics: 'false',
    pathname: '',
    setCanMakeGooglePayPayments: window.defaultFunc,
    showHeader: true,
  };

  static values = [[
    'A',
    'B',
  ], [
    'on',
    'off',
  ]];

  static getDerivedStateFromProps(props, state) {
    const { oldPropsPathname } = state;

    if (oldPropsPathname !== props.pathname) {
      return {
        expanded: false,
        functionalCookiesAllowed: getCookieGroupPermission('Functional'),
        oldPropsPathname: props.pathname,
      };
    }

    return null;
  }

  constructor() {
    super();

    this.state = {
      expanded: false,
      functionalCookiesAllowed: getCookieGroupPermission('Functional'),
    };
  }

  async componentDidMount() {
    const { features, setCanMakeGooglePayPayments,
      googlePayStubsEnabled, googlePayPaymentsClientHasBeenCreated } = this.props;
    // todo move DevConsole component to  Delivery page (after call getFeatures happens) and remove this if condition
    if (features.length > get(window.env, 'FEATURES', []).length) {
      setFeatureOverrideCookie(features);
    }
    if (this.shouldUseLocalPayPalSandbox()) {
      this.loadPayPalLibraries();
    }
    if (googlePayStubsEnabled && !googlePayPaymentsClientHasBeenCreated) {
      const stubData = await loadPaymentWalletStubs('canMakeGooglePayPayments');
      // eslint-disable-next-line no-eval
      eval(get(stubData.mockData, 'script'))(...Object.values(stubData.payload));
      setCanMakeGooglePayPayments(new window.google.payments.api.PaymentsClient({ environment: 'TEST' }));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { expanded } = this.state;
    if (!prevState.expanded && expanded) {
      document.body.addEventListener('click', this.onBodyClick);
    }
    if (prevState.expanded && !expanded) {
      document.body.removeEventListener('click', this.onBodyClick);
    }
  }

  loadPayPalLibraries = () => {
    const braintreeUrl = 'https://js.braintreegateway.com/web/3.79.1/js/client.min.js';
    const payPalUrl = 'https://js.braintreegateway.com/web/3.79.1/js/paypal-checkout.min.js';
    if (!window.braintree) {
      loadScript({
        url: braintreeUrl,
      })();
      loadScript({
        url: payPalUrl,
      })();
    }
  }

  shouldUseLocalPayPalSandbox = () => getStorageItem(featureConstants.USE_LOCAL_PAYPAL_SANDBOX_OVERRIDE, true) === 'true';

  renderFeatureItem = (item) => {
    const { id, enabled } = item;
    const value = enabled === true;
    return (
      <div key={id} data-test="feature-item">
        <Checkbox
          checked={value}
          id={id}
          label={id}
          name={id}
          onChange={evt => this.onFeatureChange(id, evt.target.checked)}
          value="true"
        />
      </div>
    );
  };

  onFeatureChange = (id, value) => {
    const { dispatch } = this.props;
    const enabled = value;
    dispatch(updateFeature(id, enabled));
  };

  onToggleClick = () => {
    this.setState({
      expanded: !this.state.expanded,
    });
  };

  onBodyClick = (evt) => {
    if (!document.getElementById('jl-checkout-dev-console').contains(evt.target)) {
      this.setState({
        expanded: false,
      });
    }
  };

  toggleLoqateMocks = (evt) => {
    const key = featureConstants.USE_REAL_LOQATE_OVERRIDE;
    if (evt.target.checked) {
      setStorageItem({
        key,
        value: true,
        local: true,
      });
    } else {
      setStorageItem({
        key,
        value: false,
        local: true,
      });
    }
  };

  togglePayPalMocks = (evt) => {
    const key = featureConstants.USE_LOCAL_PAYPAL_SANDBOX_OVERRIDE;
    if (evt.target.checked) {
      this.loadPayPalLibraries();
      setStorageItem({
        key,
        value: true,
        local: true,
      });
    } else {
      setStorageItem({
        key,
        value: false,
        local: true,
      });
    }
  };

  functionalCookiePreference = (evt) => {
    const value = evt.target.value;
    if (value === 'nopref') {
      removeCookieGroupPreference('Functional');
    }

    if (value === 'refuse') {
      refuseCookieGroup('Functional');
    }

    if (value === 'allow') {
      allowCookieGroup('Functional');
    }
  }

  render() {
    const {
      features,
      showHeader,
      applicationType,
      dispatch,
    } = this.props;
    const { expanded, functionalCookiesAllowed } = this.state;

    const featuresSorted = sortBy(features, ['id']);

    const containerClassnames = classNames(styles.container, {
      [styles.expanded]: expanded,
      [styles.noHeader]: !showHeader,
    });

    const functionalOptions = [{
      label: 'No preference',
      value: 'nopref',
    }, {
      label: 'Refuse',
      value: 'refuse',
    }, {
      label: 'Allow',
      value: 'allow',
    }];

    return (
      <div className={containerClassnames} id="jl-checkout-dev-console">
        <button
          className={styles.toggleButton}
          onClick={this.onToggleClick}
          type="button"
        >
          - Dev Console -
        </button>

        {
          expanded &&
          <div className={styles.content}>
            <div>
              <p>
                <span>ApplicationType: </span>
                <span>{applicationType}</span>
              </p>
              <div className={styles.toggles}>
                <h4>Collection cut off</h4>
                <form
                  className={styles.cutOffForm}
                  onSubmit={(event) => {
                    event.preventDefault();

                    const token = event.target.token.value;
                    const hour = event.target.hour.value;
                    const minute = event.target.minute.value;

                    window.location.assign(`/stubs/checkout?token=${token}&cut_off=${hour}%3A${minute}`);
                  }}
                >
                  <Input
                    className={styles.cutOffTokenInput}
                    defaultValue="one_man"
                    id="token"
                    name="token"
                    required
                  />
                  <Input
                    className={styles.cutOffInputNumber}
                    defaultValue=""
                    id="hour"
                    name="hour"
                    placeholder="hh"
                    required
                    type="number"
                  />
                  <Input
                    className={styles.cutOffInputNumber}
                    defaultValue=""
                    id="minute"
                    name="minute"
                    placeholder="mm"
                    required
                    type="number"
                  />
                  <SecondaryButton
                    className={styles.cutOffGo}
                    type="submit"
                  >
                    Go
                  </SecondaryButton>
                </form>
              </div>
              <div className={styles.toggles}>
                <h4>Analytics</h4>
                <Checkbox
                  checked={getStorageItem(featureConstants.LOG_ANALYTICS, true) === 'true'}
                  data-test="log-analytics-checkbox"
                  id="devConsoleLogAnalytics"
                  label="Log analytics to console"
                  name="devConsoleLogAnalytics"
                  onChange={(evt) => {
                    dispatch({ type: SET_LOG_ANALYTICS, flag: evt.target.checked });
                  }}
                />
              </div>
              <div className={styles.toggles}>
                <h4>Mock Integrations</h4>
                <div>
                  <Checkbox
                    checked={getStorageItem(featureConstants.USE_REAL_LOQATE_OVERRIDE, true) === 'true'}
                    data-test="loqate-checkbox"
                    id="toggleLoqateMocks"
                    label="Enable real Loqate"
                    name="toggleLoqateMocks"
                    onChange={this.toggleLoqateMocks}
                  />
                </div>
                <div>
                  <Checkbox
                    checked={this.shouldUseLocalPayPalSandbox()}
                    data-test="paypal-checkbox"
                    id="devConsolePaypalSandbox"
                    label="Enable real PayPal"
                    name="togglePayPalMocks"
                    onChange={this.togglePayPalMocks}
                  />
                </div>
              </div>
              <div className={styles.toggles}>
                <h4>PECR options</h4>
                <div>
                  <p>Functional cookies</p>
                  <Select
                    id="functionalCookiePreference"
                    label="Allow functional cookies"
                    name="functionalCookiePreference"
                    onChange={this.functionalCookiePreference}
                    options={functionalOptions}
                    value={functionalCookiesAllowed}
                  />
                </div>
              </div>
              {
                (env.isClientLocal || env.isClientDev) &&
                <div className={styles.toggles}>
                  <h4>Apple Pay</h4>
                  <PaymentWalletStubs
                    stubName="canMakeApplePayPayments"
                  />
                </div>
              }
              {
                (env.isClientLocal || env.isClientDev) &&
                <div className={styles.toggles}>
                  <h4>Google Pay</h4>
                  <PaymentWalletStubs
                    stubName="canMakeGooglePayPayments"
                  />
                </div>
              }
              { /* todo move DevConsole component to  Delivery page (after call getFeatures happens) and remove this if condition */
                features.length > get(window.env, 'FEATURES', []).length &&
                <div className={styles.toggles}>
                  <h4>Server Controlled Features</h4>
                  {
                    featuresSorted.map(item => this.renderFeatureItem(item))
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    );
  }
}

export default connect(state => ({
  googlePayStubsEnabled: get(state, 'app.googlePayStubsEnabled'),
  googlePayPaymentsClientHasBeenCreated: get(state, 'payment.googlePayPaymentsClientHasBeenCreated'),
  pathname: get(state, 'router.location.pathname', ''),
  applicationType: get(state, 'app.applicationType'),
  logAnalytics: get(state, 'diagnostics.logAnalytics'),
  features: get(state, 'config.features'),
}), dispatch => ({
  dispatch,
  setCanMakeGooglePayPayments,
}))(DevConsole);
